import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { mapValues, get } from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { useHighlightingStyles } from './UseHighlightingStyles';
import { getUrlParamFromEncodedState } from '../../utilities/FilterStateUrlUtilities';
import ResultRow from './ResultRow';
import Link from '../links/Link';

const RESULT_CONTAINERS = {
    server: NameDescriptionIpAddressContainer,
    device: NameDescriptionIpAddressContainer,
    wirelesscontroller: NameDescriptionIpAddressContainer,
    accesspoint: NameDescriptionIpAddressContainer,
    virtualmachine: NameDescriptionIpAddressContainer,
    hypervisor: NameDescriptionIpAddressContainer,
};

const useLinkResultRowStyles = makeStyles((theme) => ({
    root: {
        '& a': {
            color: theme.palette.text.primary,

            '&:hover': {
                textDecoration: 'none',
            },
        },

        '& .disable-overflow': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
}));

export default function LinkResultRow(props) {
    // This is the... DANGER ZONE!!!
    /* eslint-disable react/no-danger */

    const { result } = props;
    const { type, link, filterMapping } = result;
    const classes = useLinkResultRowStyles();

    const urlParams = getUrlParamFromEncodedState(mapValues(filterMapping, (mapping) => get(result, mapping)));
    const url = `${link.target}?${urlParams}`;

    const { annotatedText } = useHighlightingStyles();
    const title = result.plm ? i18n._(t`Local: ${result.plm}`) : undefined;

    const ResultContainer = RESULT_CONTAINERS[type] || NameDescriptionContainer;

    return (
        <ResultRow className={clsx(classes.root, annotatedText)} clickable hoverable>
            <Link to={url} plmIdDefault={result.plmId} title={title}>
                <ResultContainer result={result} />
            </Link>
        </ResultRow>
    );
}

function NameDescriptionContainer(props) {
    const {
        result: { name, description },
    } = props;

    return (
        <>
            <Typography variant="subtitle2">
                <div className="disable-overflow" dangerouslySetInnerHTML={{ __html: name }} />
            </Typography>
            <Typography variant="caption">
                <div className="disable-overflow" dangerouslySetInnerHTML={{ __html: description }} />
            </Typography>
        </>
    );
}

function NameDescriptionIpAddressContainer(props) {
    const {
        result: { name, description, ipAddress },
    } = props;

    return (
        <>
            <Typography variant="subtitle2">
                <div className="disable-overflow">
                    <span dangerouslySetInnerHTML={{ __html: name }} />
                    <span>
                        &nbsp; (<span dangerouslySetInnerHTML={{ __html: ipAddress }} />)
                    </span>
                </div>
            </Typography>
            <Typography variant="caption">
                <div className="disable-overflow" dangerouslySetInnerHTML={{ __html: description }} />
            </Typography>
        </>
    );
}
